import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "sh-box",
  role: "dialog",
  "aria-label": "Atalhos de teclado"
}
const _hoisted_2 = { class: "sh-body" }
const _hoisted_3 = { class: "sh-section" }
const _hoisted_4 = { class: "sh-row" }

import { computed } from 'vue'
import { shortcutsHelpOpen, closeShortcutsHelp } from '@/composables/useShortcutsHelp'
import { useAdmin } from '@/composables/useAdmin'


export default /*@__PURE__*/_defineComponent({
  __name: 'ShortcutsHelp',
  setup(__props) {

const open  = shortcutsHelpOpen
const { globalSettings } = useAdmin()
// Reflete a chave "Envio de Aviso Interno" de Configurações Gerais (kill-switch
// geral, independente de perfil) — não a permissão broadcast.send em si, que
// segue controlando se o atalho de fato funciona pra este usuário.
const broadcastEnabled = computed(() => globalSettings.value.broadcastEnabled)
function close() { closeShortcutsHelp() }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "sh-fade" }, {
      default: _withCtx(() => [
        (_unref(open))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sh-overlay",
              onMousedown: _withModifiers(close, ["self"])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", { class: "sh-header" }, [
                  _cache[1] || (_cache[1] = _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("rect", {
                      x: "2",
                      y: "7",
                      width: "20",
                      height: "14",
                      rx: "2",
                      ry: "2"
                    }),
                    _createElementVNode("path", { d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" })
                  ], -1)),
                  _cache[2] || (_cache[2] = _createTextVNode(" Atalhos de Teclado ", -1)),
                  _createElementVNode("button", {
                    class: "sh-close",
                    onClick: close
                  }, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round"
                    }, [
                      _createElementVNode("line", {
                        x1: "18",
                        y1: "6",
                        x2: "6",
                        y2: "18"
                      }),
                      _createElementVNode("line", {
                        x1: "6",
                        y1: "6",
                        x2: "18",
                        y2: "18"
                      })
                    ], -1)
                  ]))])
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "sh-section-title" }, "Geral", -1)),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "/")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Abrir busca global")
                    ], -1)),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "Ctrl"),
                        _createElementVNode("span", { class: "sh-plus" }, "+"),
                        _createElementVNode("kbd", null, "K")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Abrir busca global")
                    ], -1)),
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "?")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Ver atalhos")
                    ], -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "Esc")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Fechar janela ativa")
                    ], -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "K")
                      ], -1)),
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "sh-desc" }, "Enviar aviso para agentes", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["sh-status", broadcastEnabled.value ? 'sh-status--on' : 'sh-status--off'])
                      }, _toDisplayString(broadcastEnabled.value ? 'Habilitado' : 'Desabilitado'), 3)
                    ])
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "sh-divider" }, null, -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "sh-section" }, [
                    _createElementVNode("div", { class: "sh-section-title" }, "Conversas"),
                    _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "N")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Próxima conversa na lista")
                    ]),
                    _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "P")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Conversa anterior na lista")
                    ]),
                    _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "R")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Focar campo de resposta")
                    ]),
                    _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "C")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Abrir minhas conversas")
                    ]),
                    _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "M")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Abrir Modo Foco")
                    ]),
                    _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "Ctrl"),
                        _createElementVNode("span", { class: "sh-plus" }, "+"),
                        _createElementVNode("kbd", null, "↵")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Enviar mensagem")
                    ])
                  ], -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "sh-divider" }, null, -1)),
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "sh-section" }, [
                    _createElementVNode("div", { class: "sh-section-title" }, "Navegação"),
                    _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "↑"),
                        _createElementVNode("kbd", null, "↓")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Navegar nos resultados da busca")
                    ]),
                    _createElementVNode("div", { class: "sh-row" }, [
                      _createElementVNode("div", { class: "sh-keys" }, [
                        _createElementVNode("kbd", null, "↵")
                      ]),
                      _createElementVNode("div", { class: "sh-desc" }, "Abrir item selecionado na busca")
                    ])
                  ], -1))
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "sh-footer" }, [
                  _createTextVNode(" Pressione "),
                  _createElementVNode("kbd", null, "?"),
                  _createTextVNode(" a qualquer momento para ver esta tela ")
                ], -1))
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})